module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens11-154a2726e97c76581cc093171f05df46.jpg";